import screen from '@/mixins/screen'

export default {
  mixins: [screen],

  async beforeMount () {
    if (!this.screen.breakPoint.tabPort && this.$route.name !== 'more') {
      await this.$router.push({
        name: 'more',
        query: {
          section: this.$route.name
        }
      })
    } else if (this.screen.breakPoint.tabPort && this.$route.name === 'more' && typeof this.$route.query.section === 'string') {
      await this.$router.push({
        name: this.$route.query.section
      })
    }
  },

  watch: {
    async 'screen.breakPoint.tabPort' (val) {
      if (!val && this.$route.name !== 'more') {
        await this.$router.push({
          name: 'more',
          query: {
            section: this.$route.name
          }
        })
      } else if (this.screen.breakPoint.tabPort && this.$route.name === 'more' && typeof this.$route.query.section === 'string') {
        await this.$router.push({
          name: this.$route.query.section
        })
      }
    }
  }
}
